import React, { Component } from "react";

import { Row, Col, Grid, Image} from 'react-bootstrap';

import "./About.css"

import xc from "./images/xc.jpg";
import jj from "./images/jj.jpg";
import lulu from "./images/lulu.jpg";

class About extends Component {
  render() {
    return (
      <div>
        <Grid>
          <h1>Our Team</h1>
        </Grid>
        <div className="about-box">
          <Grid>
            <Row className="about-row">
              <Col xs={12} md={4}>
                <div className="about-profile">
                  <Image src={xc} alt="" responsive circle/>
                  <p className="about-name">Xin Cai</p>
                  <p className="about-title">Founder, Designer</p>
                  <div className="divider" />
                  <p className="about-detail">Interior Designer with 8 years experience.</p>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div className="about-profile">
                  <Image src={jj} alt="" responsive circle/>
                  <p className="about-name">Jingjing Tang</p>
                  <p className="about-title">Interior Designer</p>
                  <div className="divider" />
                  <p className="about-detail">An interior designer with 4 years experience on staging and interior design.</p>
                </div>
              </Col>
              <Col xs={12} md={4}>
                <div className="about-profile">
                  <Image src={lulu} alt="" responsive circle/>
                  <p className="about-name">Wenlu Zhang</p>
                  <p className="about-title">Interior Designer</p>
                  <div className="divider" />
                  <p className="about-detail">An interior designer, graduated from Academy of Art University.</p>
                </div>
              </Col>
            </Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default About;


// WEBPACK FOOTER //
// ./src/About.js